import { motion } from "framer-motion";

const frames = [
  {
    src: "https://images.unsplash.com/photo-1657208431551-cbf415b8ef26?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwzfHxkaiUyMHN0YWdlJTIwc3BvdGxpZ2h0JTIwZGFyayUyMGNvbmNlcnQlMjBhdG1vc3BoZXJlfGVufDB8fHx8MTc4ODg1MTQwOXww&ixlib=rb-4.1.0&q=85",
    label: "Spotlight / 01",
    title: "Licht im präzisen Rahmen",
  },
  {
    src: "https://images.unsplash.com/photo-1470229722913-7c0e2dbbafd3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDZ8MHwxfHNlYXJjaHw0fHxlbGVjdHJvbmljJTIwbXVzaWMlMjBldmVudCUyMGZlc3RpdmFsJTIwc3RhZ2UlMjBsaWdodHMlMjBjcm93ZHxlbnwwfHx8fDE3ODg4NTE0MDZ8MA&ixlib=rb-4.1.0&q=85",
    label: "Crowd / 02",
    title: "Kinetische Energie",
  },
  {
    src: "https://images.unsplash.com/photo-1514525253161-7a46d19cd819?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDZ8MHwxfHNlYXJjaHwzfHxlbGVjdHJvbmljJTIwbXVzaWMlMjBldmVudCUyMGZlc3RpdmFsJTIwc3RhZ2UlMjBsaWdodHMlMjBjcm93ZHxlbnwwfHx8fDE3ODg4NTE0MDZ8MA&ixlib=rb-4.1.0&q=85",
    label: "Pilot / 03",
    title: "Die erste Community",
  },
];

export const Experience = () => (
  <section id="erlebnis" className="px-5 py-24 sm:px-8">
    <div className="mx-auto max-w-7xl">
      <div className="mb-14 flex flex-col justify-between gap-6 lg:flex-row lg:items-end">
        <div>
          <p className="font-mono text-xs uppercase tracking-[0.24em] text-[#E5C378]">Erlebnis</p>
          <h2 className="mt-4 max-w-2xl font-syne text-3xl font-bold tracking-tight text-white sm:text-4xl lg:text-5xl">Echte Bühne, scharfes Licht, kuratierter Zugang.</h2>
        </div>
        <p className="max-w-md text-base leading-relaxed text-zinc-400">Jedes Bild trägt die Exklusivität der Registrierung und die Energie des Vyora Pilot Events am 03.10.2026.</p>
      </div>
      <div className="grid gap-6 lg:grid-cols-3">
        {frames.map((frame, index) => (
          <motion.figure key={frame.label} initial={{ opacity: 0, y: 42 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-80px" }} transition={{ duration: 0.7, delay: index * 0.12 }} className={index === 1 ? "lg:translate-y-12" : ""}>
            <div className="spotlight-frame relative h-[26rem] overflow-hidden rounded-[2rem] border border-white/10">
              <img src={frame.src} alt={frame.title} className="h-full w-full object-cover transition-transform duration-700 hover:scale-105" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent" />
              <figcaption className="absolute bottom-0 left-0 right-0 p-6">
                <p className="font-mono text-xs uppercase tracking-[0.2em] text-[#E5C378]">{frame.label}</p>
                <h3 className="mt-2 font-syne text-2xl font-bold text-white">{frame.title}</h3>
              </figcaption>
            </div>
          </motion.figure>
        ))}
      </div>
    </div>
  </section>
);
